import React from 'react';

const processSteps = [
  {
    number: '01',
    title: 'Initial Conversation',
    description: 'Confidential discussion to understand your business and objectives.',
  },
  {
    number: '02',
    title: 'Information Review',
    description: 'Subject to NDA, we review accounts and key contracts.',
  },
  {
    number: '03',
    title: 'Indicative Offer',
    description: 'Written offer with transparent rationale. Subject to due diligence and financing.',
  },
  {
    number: '04',
    title: 'Due Diligence & Completion',
    description: 'Typically 8–12 weeks, subject to financing.',
  },
];

const Process = () => {
  return (
    <section 
      id="process" 
      className="py-16 px-6 bg-section-light"
      data-testid="process-section"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-3 tracking-tight">
          How the Process Works
        </h2>
        <p className="text-[#5a5a5a] mb-8">
          Structured to minimise disruption and provide clarity at every stage.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {processSteps.map((step, index) => (
            <div 
              key={index} 
              className="section-card p-5"
              data-testid={`process-step-${index}`}
            >
              <div className="w-10 h-10 rounded-full bg-[#1e3a5f] flex items-center justify-center text-white font-bold text-sm mb-3">
                {step.number}
              </div>
              <h3 className="text-sm font-semibold text-[#1a1a1a] mb-1">
                {step.title}
              </h3>
              <p className="text-[#5a5a5a] text-xs leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
